
import { Component, OnInit, NgZone } from '@angular/core';

import { ListingBaseComponent } from 'src/core/sharepoint/model/listingbase-component';
import { RepositoryService } from 'src/core/sharepoint/services/repository';
import { TranslateService } from '@ngx-translate/core';
import { Language, Mode } from 'src/core/utility/enums/enums';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';
import { newsConstants } from 'src/shared/news/models/news-const';
import { MapperCONFIG } from 'src/core/sharepoint/model/mapper';
import { NewsMapper } from 'src/shared/news/models/news-mapper';
import { LoadingScreenService } from 'src/core/components/loader/services/loader.service';

@Component({
  selector: 'adahi-news-home',
  templateUrl: './news-home.component.html',
  providers:[
    { provide: MapperCONFIG, useClass: NewsMapper },
  ]
})
export class NewsHomeComponent extends ListingBaseComponent implements OnInit {
  
  appSettings: IAppConfig;
  newsListingPageUrl:string;
  currenLanguage:string;
  backUrl:string;

  constructor(private repositoryService: RepositoryService, ngZone: NgZone, translate: TranslateService,public LoadingScreenService:LoadingScreenService) {
    super( ngZone, translate,LoadingScreenService);
    this.appSettings = AppConfig.settings;
    this.currenLanguage=Language[_spPageContextInfo.currentLanguage];
    this.newsListingPageUrl = newsConstants.slash+ this.currenLanguage +this.appSettings.newsListingPageUrl;
    this.backUrl="/"+this.currenLanguage+this.appSettings.homeUrl;
  }

  ngOnInit() {
    this.LoadingScreenService.startLoading();
    this.translate.getTranslation(this.translate.defaultLang).subscribe((res) => {
      this.repositoryService.getItemsPaging(newsConstants.slash+ this.currenLanguage, this.translate.instant('news.newsList'), newsConstants.camlQuery.newsHome, this.onSuccessPaging, this.onError, this.onNoAvailableData);

    });
  }

  onNoAvailableData = () => {
    this.ngZone.run(() => {
        this.LoadingScreenService.stopLoading();
        this.EndcallAPIEvent.emit();
        this.status = Mode.Empty;
        
    });
}
  
 
}
